let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e19Zv")).then(() => parcelRequire('nSMSQ'));